import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalState';

const JoinGame = ({ prefillCode = '' }) => {
  const [name, setName] = useState('');
  const [gameCode, setGameCode] = useState(prefillCode);
  const [formError, setFormError] = useState('');
  const { game, joinGame } = useContext(GlobalContext);
  const history = useHistory();

  const handleJoinGame = async () => {
    const code = gameCode.trim();
    if (!name.trim()) {
      setFormError('Enter your name to join.');
      return;
    }
    if (!code) {
      setFormError('Enter the game code.');
      return;
    }
    setFormError('');
    const gameData = await joinGame(code, name.trim());
    if (gameData?.code) {
      history.push(`/join/${gameData.code}`);
    }
  };

  return (
    <div id="tm__joinGame" className="tm2">
      <div className="box" style={{ textAlign: 'left' }}>
        <h3 style={{ marginTop: '0' }}>Already have a code?</h3>

        <p>
          <label htmlFor="txt__joinGameName">Name:</label>
          <input
            type="text"
            id="txt__joinGameName"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </p>

        <p>
          <label htmlFor="gamecode">Code:</label>
          <input
            type="text"
            id="gamecode"
            value={gameCode}
            onChange={(e) => setGameCode(e.target.value)}
          />
        </p>

        <p>
          <button
            className="btn"
            onClick={handleJoinGame}
            disabled={game?.loading}
          >
            {game?.loading ? 'Joining...' : 'Join Game'}
          </button>
        </p>

        {(formError || game?.error) && (
          <p className="error" role="alert">
            {formError || game.error}
          </p>
        )}
      </div>
    </div>
  );
};

export default JoinGame;
